import { ShieldCheck, Clock, Award, Users } from "lucide-react";
import { MEDIA, waLink } from "@/lib/constants";

const STATS = [
  { icon: Clock, label: "Atendimento", value: "24h" },
  { icon: Award, label: "Anos de Estrada", value: "10+" },
  { icon: Users, label: "Clientes Atendidos", value: "5.000+" },
  { icon: ShieldCheck, label: "Satisfação", value: "100%" },
];

export const About = () => {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="section-pad relative overflow-hidden"
    >
      <div className="container-custom grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative">
          <div className="absolute -inset-4 border-2 border-[#d90429]/30 -z-10"></div>
          <img
            src={MEDIA.truck3}
            alt="Frota Auto Socorro Ventania Ribeirão Preto"
            className="w-full aspect-[4/3] object-cover"
            loading="lazy"
          />
          <div className="absolute -bottom-6 right-2 md:-right-6 bg-[#d90429] p-4 md:p-6 max-w-[190px] md:max-w-[220px] shadow-xl">
            <div className="overline text-white/80 mb-1">Desde 2015</div>
            <div className="font-display uppercase text-white font-bold text-xl leading-tight">
              Rapidez & Segurança garantidas
            </div>
          </div>
        </div>

        <div>
          <span className="overline">Quem Somos</span>
          <h2
            data-testid="about-title"
            className="mt-3 font-display uppercase font-bold text-white text-4xl md:text-5xl leading-tight tracking-tight"
          >
            Auto Socorro <span className="text-[#d90429]">Ventania</span>
            <br />— Rapidez e Segurança
          </h2>

          <div className="mt-6 space-y-4 text-gray-300 leading-relaxed">
            <p>
              A <strong className="text-white">AUTO SOCORRO VENTANIA</strong>{" "}
              atua em Ribeirão Preto/SP oferecendo serviços de guincho e auto
              socorro{" "}
              <strong className="text-[#d90429]">24 horas por dia</strong> com
              rapidez, segurança e total compromisso com o cliente.
            </p>
            <p>
              Atendemos carros, motos, camionetes, trailers, carretinhas e
              diversos tipos de veículos, realizando{" "}
              <strong className="text-white">
                remoções locais e viagens para todas as cidades e estados
              </strong>
              .
            </p>
            <p>
              Seja em pane mecânica, acidentes, transporte de veículos ou
              emergências, nossa equipe está pronta para atender a qualquer
              hora do dia ou da noite.
            </p>
            <p className="text-white font-display uppercase tracking-wider text-lg">
              Precisou de guincho? É só ligar!
            </p>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-4">
            {STATS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={i}
                  className="card-dark p-5 flex items-center gap-4"
                  data-testid={`about-stat-${i}`}
                >
                  <Icon className="w-8 h-8 text-[#d90429] shrink-0" />
                  <div>
                    <div className="font-display uppercase font-bold text-2xl text-white leading-none">
                      {s.value}
                    </div>
                    <div className="text-xs uppercase tracking-wider text-gray-400 mt-1">
                      {s.label}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-whatsapp-cta"
            className="btn-wa mt-10 text-base"
          >
            <i className="fa-brands fa-whatsapp text-xl" aria-hidden></i>
            Fale com a Equipe Agora
          </a>
        </div>
      </div>
    </section>
  );
};
